import ApiService from '@/services/api'
import cloneDeep from 'lodash/cloneDeep'
// import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  aliasNameIsAlReady: true,
  isLoading: false
}

const getters = {
  isLoading: state => state.isLoading,
  getData: state => cloneDeep(state.data),
  getTotalData: state => cloneDeep(state.totalData),
  getIsAliasNameAlready: state => state.aliasNameIsAlReady
}

// mutations
const mutations = {
  loading(state) {
    state.isLoading = true
  },
  success(state, { data, total }) {
    state.data = data
    state.totalData = total
    state.isLoading = false
  },
  setData(state, { data, total }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    state.data.push(model)
    state.totalData = state.totalData + 1
  },
  updateData(state, model) {
    console.log('func uddateData', model)
    console.log('state.data', state.data)
    const index = state.data.findIndex(m => m.id === model.id)
    console.log('index :', index)
    state.data[index] = model
  },
  deleteData(state, id) {
    const index = state.data.findIndex(m => m.id === id)
    state.data.splice(index, 1)
  },
  checkApiAliasData(state, isAliasAlready) {
    state.aliasNameIsAlReady = isAliasAlready
  }
}

const actions = {
  findAll({ commit, state }, options) {
    return ApiService.findAll(options).then(({ result, paginate }) => {
      const data = result.map(item => {
        const endpointUrl = item.endpoint.endpoint_url
        const strFilters = item.filters.map(f => f.name).toString()
        const sourceType = item.tables.length > 0 ? (item.views.length > 0 ? 'Table, View' : 'Table') : 'View'
        const sourceName = item.tables.map(t => t.name).toString() + item.views.map(v => v.name).toString()
        const groupName = item.api_group.name
        return { ...item, endpointUrl, strFilters, sourceType, sourceName, groupName }
      })
      commit('setData', { data, total: paginate.total })
    })
  },
  save({ commit, state }, model) {
    console.log('func save :', model)
    delete model.endpointUrl
    delete model.strFilters
    delete model.sourceType
    delete model.sourceName
    if (!model.id) {
      return ApiService.create(model).then((res) => {
        if (res && (res.error_message || res.message || res.status === 'fail' || res.status === 'error' || res.code >= 400)) {
          const error = res && res.response && res.response.data ? res.response.data : res
          return Promise.reject(error)
        }
        if (res && res.result) {
          commit('appendData', res.result)
          return res.result
        }
        return res
      })
    } else {
      return ApiService.update(model).then((res) => {
        if (res && (res.error_message || res.message || res.status === 'fail' || res.status === 'error' || res.code >= 400)) {
          const error = res && res.response && res.response.data ? res.response.data : res
          return Promise.reject(error)
        }
        if (res && res.result) {
          return res.result
        }
        return res
      })
    }
  },
  delete({ commit, state }, id) {
    return ApiService.delete(id).then((res) => {
      commit('deleteData', id)
    })
  },
  checkApiAlias({ commit, state }, aliasPayload) {
    return ApiService.checkApiAlias(aliasPayload).then((res) => {
      commit('checkApiAliasData', res)
      return res
    })
  },
  fetchFilters({ commit, state }, id) {
    commit('loading')
    return ApiService.find(id).then(resp => {
      const dataFilters = resp.filters.map((f, index) => {
        return {
          id: index,
          name: f.name,
          activate: f.activate,
          created_by: resp.created_by,
          created_at: resp.created_at,
          updated_by: resp.updated_by,
          updated_at: resp.updated_at
        }
      })
      resp['dataFilters'] = dataFilters
      const data = resp
      commit('success', { data, total: 0 })
    })
  },
  saveFilter({ commit, state }, data) {
    delete data.dataFilters
    if (!data.id) {
      return ApiService.create(data)
    } else {
      return ApiService.update(data)
    }
  }
}

export default {
  namespaced: true,
  state: cloneDeep(state),
  getters,
  actions,
  mutations
}
